module.exports = __webpack_public_path__ + "img/华域三电.png";